import { render } from "./SelfieCapture.vue?vue&type=template&id=0e2bf626&scoped=true"
import script from "./SelfieCapture.vue?vue&type=script&lang=js"
export * from "./SelfieCapture.vue?vue&type=script&lang=js"

import "./SelfieCapture.vue?vue&type=style&index=0&id=0e2bf626&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2bf626"]])

export default __exports__